import _ from 'lodash';
import Vue from 'vue';
import {mapActions, mapState, mapGetters} from 'vuex';
import {required, maxLength, minLength, helpers} from 'vuelidate/lib/validators';
import EventHub from '../../lib/eventHub';
import {AxiosResponse} from 'axios';
import BioConfigService from '../../lib/services/bioConfigService';
import {BioProfileModuleConstant, BioServicesConstant, EmployeeProfileModuleConstant, EventConstant, RoleConfigs, UrlModuleConstant} from '../../lib/constants';
import ManageTestimonials from './manage-testimonials.html';
import BioAdmin from 'types/ba/bioAdmin';
import BioProfileService from '../../lib/services/bioProfileService';
import BioProfileMuleService from '../../lib/services/bioProfileMuleService';

const bioConfigService: BioAdmin.IBioConfigService = new BioConfigService();
const bioProfileService: BioAdmin.IBioProfileService = new BioProfileService();
const bioProfileMuleService: BioAdmin.IBioProfileService = new BioProfileMuleService();
// custom validators
const textValidate = helpers.regex('textValidate', BioServicesConstant.textfieldRegexValidator);

interface IComponentData {
	bioProfileServiceLoading: boolean;
	window: Window;
	profileParam: number;
	testimonials: BioAdmin.ITestimonial[];
	roles: string[];
	biosConfigResponse: BioAdmin.IBiosConfigResponse;
	roleFeatures: string[];
	editId: number;
	editIndex: number;
	isClubLead: boolean;
	form: BioAdmin.ITestimonialFormValidator;
	useSpringApi: boolean;
}

export default Vue.component('manageTestimonials', {
	template: ManageTestimonials,
	data(): IComponentData {
		return {
			bioProfileServiceLoading: true,
			window: window,
			profileParam: 0,
			testimonials: [],
			roles: [],
			biosConfigResponse:  {
				rolesFeatures: [
					{
						roleId: 1,
						roleName : 'Personal Trainer',
						features: [
							'contact',
							'quote'
						]
					}],
				features:
				{
					quote: {
						maxLength: '50',
					},
					contact: {}
				}
			},
			roleFeatures: [],
			editId: 0,
			editIndex: -1,
			isClubLead: true, // see computed()
			form: {
				editText: '',
			},
			useSpringApi: false,
		};
	},
	computed: {
		...mapState(BioProfileModuleConstant.name, [
			'bioProfile',
		]),
		...mapState(EmployeeProfileModuleConstant.name, [
			'employeeProfile',
		]),
		...mapGetters(UrlModuleConstant.name, {
			getGlobalPageDriverUrl: UrlModuleConstant.getter.getGlobalPageDriverUrl,
			getUrlParameter: UrlModuleConstant.getter.getUrlParameter,
		}),
		...mapGetters(EmployeeProfileModuleConstant.name, {
			getEmployeeId: EmployeeProfileModuleConstant.getter.getEmployeeId,
		}),
		// TO DO re-enable security around permissions
		// For now, this variable will be set to 'true' always
		// isClubLead(): boolean {
		// 	return this.hasRole(BioServicesConstant.clubLeadString);
		// }
	},
	methods: {
		...mapActions(BioProfileModuleConstant.name, {
			getBioProfile: BioProfileModuleConstant.action.getProfile,
		}),
		...mapActions(EmployeeProfileModuleConstant.name, {
			synchronizeEmployeeProfileStore: EmployeeProfileModuleConstant.action.synchronize,
		}),
		...mapActions(UrlModuleConstant.name, {
			synchronizeUrlStore: UrlModuleConstant.action.synchronize,
		}),
		goTo(page: string, profileParam: number): void {
			if (profileParam) {
				window.location.assign(this.getGlobalPageDriverUrl('biosAdmin', page) + '?profile=' + profileParam);
			} else {
				window.location.assign(this.getGlobalPageDriverUrl('biosAdmin', page));
			}
		},
		getTestimonials(employeeId: number) {
			if (this.useSpringApi) {
				return bioProfileService.getTestimonials(employeeId).then((response: AxiosResponse<BioAdmin.ITestimonial[]>) => {
					this.testimonials = response.data;
				});
			} else {
				return bioProfileMuleService.getTestimonials(employeeId).then((response: AxiosResponse<BioAdmin.ITestimonial[]>) => {
					this.testimonials = response.data;
				});
			}
		},
		openTestimonialEdit(testimonial: BioAdmin.ITestimonial, index: number) {
			this.editId = testimonial.id;
			this.editIndex = index;
			this.form.editText = testimonial.testimonial;
			$('#testimonialEditName').text(testimonial.firstName + ' ' + testimonial.lastNameInitial + '.');
			// @ts-ignore
			$('#testimonialEdit').modal('show');
		},
		openTestimonialDelete(testimonialId: number, index: number) {
			this.editId = testimonialId;
			this.editIndex = index;
			// @ts-ignore
			$('#confirmDelete').modal('show');
		},
		submitTestimonialEdit() {
			const employeeId: number = this.profileParam || this.getEmployeeId;
			const testimonialId: number = this.editId;
			const text: string = (this.form.editText) ? this.form.editText : '';
			if (this.useSpringApi) {
				return bioProfileService.editTestimonialText(employeeId, testimonialId, text)
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						this.testimonials[this.editIndex].testimonial = text;
						// @ts-ignore
						$('#testimonialEdit').modal('hide');
					});
			} else {
				return bioProfileMuleService.editTestimonialText(employeeId, testimonialId, text)
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						this.testimonials[this.editIndex].testimonial = text;
						// @ts-ignore
						$('#testimonialEdit').modal('hide');
					});
			}
		},
		approveTestimonial(testimonial: BioAdmin.ITestimonial) {
			const employeeId: number = this.profileParam || this.getEmployeeId;
			if (this.useSpringApi) {
				return bioProfileService.setTestimonialStatus(employeeId, testimonial.id, 'approve')
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						testimonial.status = 'approved';
						testimonial.visible = true;
					});
			} else {
				return bioProfileMuleService.setTestimonialStatus(employeeId, testimonial.id, 'approve')
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						testimonial.status = 'approved';
						testimonial.visible = true;
					});
			}
		},
		rejectTestimonial(testimonialId: number, index: number) {
			const employeeId: number = this.profileParam || this.getEmployeeId;
			if (this.useSpringApi) {
				return bioProfileService.setTestimonialStatus(employeeId, testimonialId, 'reject')
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						this.testimonials.splice(index, 1);
						// @ts-ignore
						$('#confirmDelete').modal('hide');
					});
			} else {
				return bioProfileMuleService.setTestimonialStatus(employeeId, testimonialId, 'reject')
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						this.testimonials.splice(index, 1);
						// @ts-ignore
						$('#confirmDelete').modal('hide');
					});
			}
		},
		toggleTestimonialVisibility(testimonial: BioAdmin.ITestimonial, value: boolean) {
			const id: number = this.profileParam || this.getEmployeeId;
			if (this.useSpringApi) {
				return bioProfileService.setTestimonialVisibility(id, testimonial.id, value)
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						testimonial.visible = value;
					});
			} else {
				return bioProfileMuleService.setTestimonialVisibility(id, testimonial.id, value)
					.then((response: AxiosResponse<BioAdmin.IBioProfileResponse>) => {
						testimonial.visible = value;
					});
			}
		},
		getRoleConfig() {
			return bioConfigService.getRoleConfig()
				.then((response: AxiosResponse<BioAdmin.IBiosConfigResponse>) => {
					this.biosConfigResponse = response.data;
				}).catch((error) => {
					// use config constant on localhost
					this.biosConfigResponse = RoleConfigs;
				});
		},
		hasFeature(feature: string): boolean {
			return this.roleFeatures.includes(feature);
		},
		hasRole(role: string): boolean {
			return this.roles.includes(role);
		},
		setFeaturesByRole() {
			this.roles = [];
			this.roleFeatures = [];
			// @ts-ignore
			_.forEach(this.bioProfile.roles, (profileRole: BioAdmin.IRole) => {
				const validRole: any = _.find(this.biosConfigResponse.rolesFeatures, (rc) => {
					return profileRole.name === rc.roleName;
				});
				this.roles.push(validRole.roleName);
				_.forEach(validRole.features, (feature) => {
					if (!this.roleFeatures.includes(feature)) {
						this.roleFeatures.push(feature);
					}
				});
			});
		},
	},
	created(): void {
		EventHub.$on(EventConstant.BioProfileServiceLoading, (loading: boolean) => {
			this.bioProfileServiceLoading = loading;
		});

		Promise.all([this.synchronizeEmployeeProfileStore(), this.synchronizeUrlStore(), this.getRoleConfig()]).then(() => {
			const featureFlags = window.lt.features;
			if(featureFlags) {
				const feature = featureFlags[featureFlags.findIndex( (x: any) => x.featureId === 'biosSpringApi')];
				if(feature && feature.enabled)
				this.useSpringApi = true;
			}
			this.profileParam = this.getUrlParameter('profile');
			if (this.profileParam > 0) {
				this.getTestimonials(this.profileParam);
			} else {
				this.getTestimonials(this.employeeProfile.employeeDetails.employeeId);
			}
			this.getBioProfile().then(() => {
				this.setFeaturesByRole();
			});
		});
	},
	mounted(): void {
		this.$nextTick(() => {
			const data = this;
			$('body').on('hidden.bs.modal', () => {
				data.editId = 0;
				data.editIndex = -1;
				data.form.editText = '';
			});
		});
	},
	validations() {
		const form: any = {};
		form['editText'] = {
			required,
			minLength: minLength(10),
			maxLength: maxLength(1500),
			textValidate,
		};
		return {
			form,
		};
	},
});
